import React from 'react';


const Footer = () => {
    return (
        <React.Fragment>

            <section className='container-fluid footer px-4 py-3'>
                <div className="row">
                    <div className="col-12">
                        Copyright Cheap Ship Group All Rights Reserved
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default Footer;
